module.exports = __webpack_public_path__ + "media/packs/fonts/UtopiaStd-Italic-a3f42e4118c39099c4ec46a89c0dbd85.woff2";